import { useIsPatientSpecific } from "./useIsPatientSpecific";
const TabTitle = ({ tab: { title, PageTitle, PatientName, VisitAccount, menuId, modified }, }) => {
    const isPatientSpecific = useIsPatientSpecific(menuId);
    const patientWithAcc = `${PatientName} (${VisitAccount})`;
    return title ? (PatientName && isPatientSpecific ? (<span>
        {patientWithAcc === title ? PageTitle : title} /{" "}
        <b>
          {PatientName} ({VisitAccount}){modified ? "*" : ""}
        </b>
      </span>) : (<>{title}</>)) : (<>Title not specified</>);
};
export default TabTitle;
